const AuxDiv = props => props.children;
export default AuxDiv;
